import { useState, useCallback, useEffect } from 'react'

const ONBOARDING_STORAGE_KEY = 'mosaico_onboarding_completed'

export const useOnboarding = () => {
  const [showOnboarding, setShowOnboarding] = useState(false)

  useEffect(() => {
    const isCompleted = localStorage.getItem(ONBOARDING_STORAGE_KEY)
    if (!isCompleted) {
      setShowOnboarding(true)
    }
  }, [])

  const completeOnboarding = useCallback(() => {
    localStorage.setItem(ONBOARDING_STORAGE_KEY, 'true')
    setShowOnboarding(false)
  }, [])

  return {
    showOnboarding,
    completeOnboarding,
  }
}
